export default __webpack_public_path__ + "static/media/giaithan.e61d3597.png";